export default __webpack_public_path__ + "static/media/Pretendard-Medium.ea235f1e.woff2";